import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ProductChainModal, ProductChainDetails } from "./types";

const initialState: ProductChainModal = {
  productChainDetails: {
    climsId: "",
    sampleImage: "",
    growerNote: "",
    coaPdfIpfsHash: "",
    strainName: "",
    strainType: "",
    productImage: "",
    manufacturerInfo: {
      name: "",
      companyName: "",
    },
    blockchainInfo: {
      tokenStandard: "",
      chainName: "",
      contractAddress: "",
      tokenId: "",
      contractAddressRedirectUrl: "",
      tokenIdRedirectUrl: "",
      transactionHash: "",
      productNftMetadataIpfsUrl: "",
      regulatorBatchId: "",
    },
    primaryInfo: {
      name: "",
      batchId: "",
      batchIndexId: "",
      productType: "",
      productSubType: "",
      cultivationState: "",
      cultivatorName: "",
      totalProductCount: "",
      harvestDate: "",
      packageDate: "",
    },
    keyComponents: {
      thcTotal: "",
      cbdTotal: "",
      cannabinoidTotal: "",
      topThreeCannabinoids: [],
      topThreeTerpenes: [],
      terpeneTotal: "",
    },
    maxThcMg: "",
    maxCbdMg: "",
    maxThcWeight: "",
    dataPlatform: "",
    maxCbdWeight: "",
    totalTerpenesMg: "",
    metaDataIpfsHash: "",
    totalCannabinoidsMg: "",
    totalCannabinoidsWeight: "",
    totalTerpenesPercentWeight: "",
    compoundType: "",
    totalCannabinoidsPercentWeight: "",
  },
};

const ProductChainSlice = createSlice({
  name: "productChainSlice",
  initialState,
  reducers: {
    setProductChainDetails: (
      state: ProductChainModal,
      action: PayloadAction<ProductChainDetails>,
    ) => {
      state.productChainDetails = action.payload;
    },

    setResetProductChainDetails: (state) => {
      state.productChainDetails = initialState.productChainDetails;
    },
  },
});

export const { setProductChainDetails, setResetProductChainDetails } =
  ProductChainSlice.actions;
export default ProductChainSlice.reducer;
